import { Component, forwardRef, Input } from '@angular/core'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { LocaleService } from '../../../../../../framework/locale/services/locale.service'
import { onlyTextRegex } from './configurator-steeringwheel-picker'

let _uniqueIdCounter: number = 0

@Component({
    selector: 'mg-configurator-steeringwheel-picker',
    templateUrl: './configurator-steeringwheel-picker.component.html',
    styleUrls: ['./configurator-steeringwheel-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfiguratorSteeringWheelpickerComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ConfiguratorSteeringWheelpickerComponent),
            multi: true,
        },
    ],
})
export class ConfiguratorSteeringWheelpickerComponent extends AbstractValueAccessor {
    @Input()
    public name: string = `configurator-steeringwheel-picker-component-${_uniqueIdCounter++}`
    private updateValidityTimer: NodeJS.Timer
    private steeringWheel: { value: string; description: any }[] = []
    private historicValues = []

    constructor(private localeService: LocaleService) {
        super()
    }

    get locale(): string {
        return this.localeService.locale
    }

    get selectedDescription() {
        return this.selectedChild ? this.steeringWheelKey : null
    }

    private get selectedChild() {
        return this.steeringWheel.find(({ value }) => value === this.value)
    }

    public get steeringWheelKey() {
        return this.selectedChild.description.toLowerCase().replace(' ', '-')
    }

    public get steeringWheelLabel() {
        return `${this.steeringWheelKey}-description`
    }

    registerChild(childColor: { value: string; description: any }) {
        this.steeringWheel.push(childColor)
        this.updateValidity()
    }

    removeChild(childColor: { value: string; description: any }) {
        const currentRimIndex = this.steeringWheel.findIndex(
            steeringWheel =>
                steeringWheel.value === childColor.value && steeringWheel.description === childColor.description
        )
        if (currentRimIndex > -1) {
            this.steeringWheel.splice(currentRimIndex, 1)
            this.updateValidity()
        }
    }

    registerOnChange(fn: (_: any) => void): void {
        this.onChange = value => {
            if (value) {
                const valueIndex = this.historicValues.indexOf(value)
                if (valueIndex > -1) {
                    this.historicValues.splice(valueIndex, 1)
                }
                this.historicValues = [value, ...this.historicValues]
            }

            fn(value)
        }
    }

    validate(control: FormControl) {
        const hasValue = control.value && this.steeringWheel.some(rim => rim.value === control.value)
        return hasValue ? null : { color: 'No Steering Wheel selected' }
    }

    private updateValidity() {
        clearTimeout(this.updateValidityTimer)
        this.updateValidityTimer = setTimeout(() => {
            if (!this.steeringWheel.find(value => value === this.value)) {
                const validHistoricValue = this.historicValues.find(
                    value => !!this.steeringWheel.find(steeringWheelValue => steeringWheelValue === value)
                )
                this.value = validHistoricValue
                    ? validHistoricValue
                    : this.steeringWheel.length
                    ? this.steeringWheel[0].value
                    : this.value
                this.writeValue(this.value)
            }
        }, 2)
    }
}
